import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Building2, DollarSign, Truck, Users } from 'lucide-react';
const roles = [{
  title: 'Executive Director (J3)',
  period: 'Defense Logistics Agency',
  desc: 'Directed global logistics operations supporting all Combatant Commands.'
}, {
  title: 'Acting Commander & Deputy',
  period: 'DLA Energy',
  desc: 'Managed comprehensive energy solutions for the Department of Defense and federal agencies.'
}, {
  title: 'Executive Director (J31/J34)',
  period: 'Operations & Sustainment',
  desc: 'Oversaw joint logistics operations and strategic sustainment initiatives.'
}];
export function SESLeadershipSection() {
  return <Section id="ses-leadership" variant="charcoal" data-id="element-346">
      <SectionHeader title="Senior Executive Service" subtitle="Defense Logistics Agency" data-id="element-347" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12" data-id="element-348">
        <div className="lg:col-span-7 space-y-6" data-id="element-349">
          {roles.map((role, index) => <Reveal key={index} delay={index * 100} data-id="element-350">
              <div className="flex gap-4 p-4 border-l-2 border-gold-500 bg-navy-900/50" data-id="element-351">
                <div data-id="element-352">
                  <h3 className="text-xl font-bold text-white uppercase" data-id="element-353">
                    {role.title}
                  </h3>
                  <p className="text-gold-500 text-sm font-heading tracking-wider mb-2" data-id="element-354">
                    {role.period}
                  </p>
                  <p className="text-slate-400 text-sm" data-id="element-355">{role.desc}</p>
                </div>
              </div>
            </Reveal>)}
        </div>

        <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-356">
          <Reveal delay={300} data-id="element-357">
            <Card className="h-full flex flex-col justify-center text-center p-6" data-id="element-358">
              <DollarSign className="w-8 h-8 text-gold-500 mx-auto mb-3" data-id="element-359" />
              <span className="text-3xl font-bold text-white block mb-1" data-id="element-360">
                $42B
              </span>
              <span className="text-xs text-slate-400 uppercase tracking-widest" data-id="element-361">
                Annual Operations
              </span>
            </Card>
          </Reveal>

          <Reveal delay={400} data-id="element-362">
            <Card className="h-full flex flex-col justify-center text-center p-6" data-id="element-363">
              <Building2 className="w-8 h-8 text-gold-500 mx-auto mb-3" data-id="element-364" />
              <span className="text-3xl font-bold text-white block mb-1" data-id="element-365">
                $10B
              </span>
              <span className="text-xs text-slate-400 uppercase tracking-widest" data-id="element-366">
                Energy Portfolio
              </span>
            </Card>
          </Reveal>

          <Reveal delay={500} data-id="element-367">
            <Card className="h-full flex flex-col justify-center text-center p-6" data-id="element-368">
              <Truck className="w-8 h-8 text-gold-500 mx-auto mb-3" data-id="element-369" />
              <span className="text-3xl font-bold text-white block mb-1" data-id="element-370">
                9
              </span>
              <span className="text-xs text-slate-400 uppercase tracking-widest" data-id="element-371">
                Supply Chains
              </span>
            </Card>
          </Reveal>

          <Reveal delay={600} data-id="element-372">
            <Card className="h-full flex flex-col justify-center text-center p-6" data-id="element-373">
              <Users className="w-8 h-8 text-gold-500 mx-auto mb-3" data-id="element-374" />
              <span className="text-3xl font-bold text-white block mb-1" data-id="element-375">
                27,000
              </span>
              <span className="text-xs text-slate-400 uppercase tracking-widest" data-id="element-376">
                Personnel Led
              </span>
            </Card>
          </Reveal>
        </div>
      </div>
    </Section>;
}